import React, { useState } from 'react';
import GiftIcon from '../../../../../ui/svg/shopping-cart/gift';
import WarningIcon from '../../../../../ui/svg/common/warning-icon';
import Preloader from '../../../../../ui/svg/common/preloader';
import { setNotificationsAction } from '../../data/data-service';
import { INotification, NotificationAction } from '../../notifications-interfaces';
import NoLettersLogo from '../../../../../ui/svg/common/no-letters-logo';
import { IStoreProps } from '../../index';
import { useDispatch } from 'react-redux';
import EmailIcon from '../../../../../ui/svg/common/email';

interface INotificationIcon {
    storeProps: IStoreProps;
    notification: INotification;
}

const getBgColorClass = (icon: string) : string => {
    switch (icon) {
        case 'error': {
            return 'bg-red';
        }
        case 'gift': {
            return 'bg-green-200';
        }
        case 'waves': {
            return 'bg-blue-200';
        }
        case 'envelope': {
            return 'bg-purple';
        }
        default: {
            return 'bg-blue-200';
        }
    }
};

const NotificationIcon = ({ storeProps, notification }: INotificationIcon) => {

    const [loading, setLoading] = useState(false);
    const icon = notification.icon || '';

    const { rootActions } = storeProps;

    const dispatch = useDispatch();

    const onClick = async () => {

        setLoading(true);

        dispatch(
            rootActions.main({
                additionalOpenedMenuNotification: null,
                additionalOpenedMenuStyles: null,
            })
        );

        await setNotificationsAction(
            notification.userNTFGUID,
            NotificationAction.Click,
        );

        window.location.href = notification.ctaUrl ?? '';
    };

    return (
        <button
            onClick={ onClick }
            type="button"
            className={ `${ getBgColorClass(icon) } flex items-center justify-center mr-3 rounded-full cursor-pointer text-white` }
            style={{
                width: '43px',
                height: '43px',
            }}>

            {
                loading &&
                <Preloader color="currentColor" width="24px" height="24px" />
            }

            {
                !loading &&
                <>
                    {
                        icon === 'error' &&
                        <WarningIcon
                            color="#fff"
                            width="24px"
                            height="24px"
                            style={{
                                marginLeft: '1px',
                                marginTop: '1px',
                            }}
                            strokeColor={ '#fff' }
                            strokeWidth={ 1 }
                        />
                    }

                    {
                        icon === 'gift' &&
                        <GiftIcon
                            color="#fff"
                            width="24px"
                            height="24px"
                            strokeWidth="1"
                            style={{
                                marginLeft: '1px',
                                marginTop: '-2px',
                            }}
                        />
                    }

                    {
                        icon === 'envelope' &&
                        <EmailIcon
                            color="#fff"
                            width="24px"
                            height="24px"
                            style={{
                                marginLeft: '1px',
                            }}
                        />
                    }

                    {
                        icon === 'waves' &&
                        <NoLettersLogo
                            color="#fff"
                            width="24px"
                            height="24px"
                            style={{
                                marginLeft: '1px',
                            }}
                        />
                    }
                </>
            }
        </button>
    )
};

export default NotificationIcon;